import {FAILURE, PENDING, SUCCESS} from '../../constants'
import {getGroupActionFields as getGroupActionFieldsAPI} from '../../../services/groups'

export async function getGroupActionFields(
  dispatch,
  {group_id, action_id, type = null, all_fields = false}
) {
  try {
    dispatch({type: PENDING})

    let response = await getGroupActionFieldsAPI({group_id, action_id, type, all_fields})

    dispatch({type: SUCCESS, payload: response, key: `${group_id}_${action_id}`})
  } catch (e) {
    console.log(`Get Group Field Values Failed: ${group_id} ${action_id}`, e)
    dispatch({type: FAILURE, payload: e})
  }
}
